export default __webpack_public_path__ + "static/media/lbng_store.a682b1c6.png";